module.exports = __webpack_public_path__ + "static/media/home-mill.a0b61bdd.jpg";